import Vue from 'vue';
import { defineStore } from 'pinia';
import _ from 'lodash';

import KnowledgeDocumentApi from '@/extensions/knowledge-base/store/api/knowledgeDocument';

export const useKnowledgeDocumentStore = defineStore('knowledgeDocument', {
    state: () => ({
        loading: true,
        knowledgeSourceId: null,
        knowledgeDocumentsPaginated: {
            variables: {
                order: 'title',
                direction: 'asc',
                paginationSizes: [25, 50, 100]
            },
            filters: {},
            pageInfo: {
                total: 0,
                perPage: 25,
                currentPage: 1,
                lastPage: 0
            },
            allColumns: [],
            activeColumns: [],
            showFilters: false,
            defaultSort: null,
            link: {},
            items: []
        }
    }),

    actions: {
        setKnowledgeSourceId(id) {
            this.knowledgeSourceId = id;
        },

        addPaginatedDocumentsToState(data) {
            this.knowledgeDocumentsPaginated.items = data.items;
            this.knowledgeDocumentsPaginated.pageInfo = _.cloneDeep(data.pageInfo);
            this.knowledgeDocumentsPaginated.allColumns = _.cloneDeep(data.config.allColumns);
            this.knowledgeDocumentsPaginated.link = _.cloneDeep(data.config.link);
            this.knowledgeDocumentsPaginated.showFilters = _.get(data.config, 'showFilters') || false;
            this.knowledgeDocumentsPaginated.defaultSort = _.get(data.config, 'defaultSort') || null;
        },

        defineActiveColumns(activeColumnKeys) {
            const activeColumns = [];
            _.each(this.knowledgeDocumentsPaginated.allColumns, column => {
                const allowed = _.find(activeColumnKeys, value => column.key === value);
                if (allowed) activeColumns.push(column);
            });

            if (activeColumns.length) {
                this.knowledgeDocumentsPaginated.activeColumns = activeColumns;
            }
        },

        defineItemsPerPage(perPage) {
            this.knowledgeDocumentsPaginated.pageInfo.perPage = perPage;
        },

        defineCurrentPage(currentPage) {
            this.knowledgeDocumentsPaginated.pageInfo.currentPage = currentPage;
        },

        defineFilterValue({ key, value }) {
            if (value.match === '' && value.like === '' && value.from === '' && value.to === '' && value.in.length === 0) {
                Vue.delete(this.knowledgeDocumentsPaginated.filters, key);
            } else {
                Vue.set(this.knowledgeDocumentsPaginated.filters, key, value);
            }
        },

        defineSorting({ key, value }) {
            this.knowledgeDocumentsPaginated.variables.order = key;
            this.knowledgeDocumentsPaginated.variables.direction = value;
        },

        defineFilterVisibility(value) {
            this.knowledgeDocumentsPaginated.showFilters = value;
        },

        updateLoading(value) {
            this.loading = value;
        },

        fetchKnowledgeDocumentsPaginated() {
            return KnowledgeDocumentApi.fetchKnowledgeDocumentsPaginated(this.knowledgeDocumentsPaginated, this.knowledgeSourceId).then(data => {
                this.addPaginatedDocumentsToState(data);

                const activeColumnKeys = _.map(data.config.activeColumnKeys, 'key');
                this.defineActiveColumns(activeColumnKeys);
            });
        }
    }
});
